var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.19 24.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.11,0c2.21,0,4.54.48,5.28,3.55l4.77,19.84c0,.06.03.13.03.16,0,.32-.22.51-.54.51h-4.48c-.32,0-.58-.26-.64-.58l-1.15-5.25h-5.22l.9-4.38h3.42l-1.95-8.83c-.06-.32-.13-.48-.42-.48-.29,0-.38.16-.45.48l-1.95,8.83h.03l-.9,4.38h-.02l-1.15,5.25c-.06.32-.32.58-.64.58H.54c-.32,0-.54-.19-.54-.51,0-.03.03-.1.03-.16L4.8,3.55C5.54.48,7.9,0,10.11,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.99998e615a73542b1d030e648c994d05.svg";
export { ForwardRef as ReactComponent };